document.addEventListener('DOMContentLoaded', function () {
  const testimonialSections = document.querySelectorAll('[data-testimonials-section]');

  testimonialSections.forEach((section) => {
    const testimonials = section.querySelectorAll('.testimonial-item');
    const prevButton = section.querySelector('.nav-arrow.prev');
    const nextButton = section.querySelector('.nav-arrow.next');
    let currentIndex = 0;

    function showTestimonial(index) {
      testimonials.forEach((testimonial) => testimonial.classList.remove('active'));
      testimonials[index].classList.add('active');
    }

    function nextTestimonial() {
      currentIndex = (currentIndex + 1) % testimonials.length;
      showTestimonial(currentIndex);
    }

    function prevTestimonial() {
      currentIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
      showTestimonial(currentIndex);
    }

    prevButton.addEventListener('click', prevTestimonial);
    nextButton.addEventListener('click', nextTestimonial);

    // Show the first testimonial
    showTestimonial(currentIndex);
  });
});
